export const detail = {
  table: {
    id: 'ID',
    detergentName: 'Detergent Name',
    quantity: 'Quantity',
    timeUnit: 'Minutes',
    unit: 'Unit',
    method: 'Method',
    detergentUsed: 'Detergent Used',
    time: 'Time',
    washingTime: 'Washing Time',
    customer: 'Customer',
    customerCode: 'Customer Code',
    customerName: 'Customer Name',
  },
  pageHeader: {
    title: 'Method Detail',
  },
}
